import { render } from "./setMealModal.vue?vue&type=template&id=39283310"
import script from "./setMealModal.vue?vue&type=script&lang=js"
export * from "./setMealModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/c7p4yP7J/0/platform/zhenwu/iot-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/setMealModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39283310"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39283310', __exports__)) {
    console.log('reload')
    api.reload('39283310', __exports__)
  }
  
  module.hot.accept("./setMealModal.vue?vue&type=template&id=39283310", () => {
    console.log('re-render')
    api.rerender('39283310', render)
  })

}


export default __exports__